import { TemplateElement, html, defineElement, when, classMap } from '@webtides/element-js';
import style from './content-cards.css';
import '../../../chip/chip.js';
import '../../../content-card/content-card.js';
import '../../../slider/slider.js';

/**
 * @property {'slider' | 'grid'} variant
 * @property {string} headline
 * @property {ContentCardProperties[]} cards
 * @property {LinkProperties} link
 */
export default class ContentCards extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            variant: 'slider',
            headline: '',
            cards: [],
            link: undefined,
        };
    }

    template() {
        const gridClasses = {
            'md:w-6/12 md:mx-auto md:grid-cols-1': this.cards?.length === 1,
            'md:w-8/12 md:mx-auto md:grid-cols-2': this.cards?.length === 2,
            'md:grid-cols-3': this.cards?.length >= 3,
        };
        return html`
            <div class="flex flex-col gap-fix-s lg:gap-fix-m">
                ${when(
                    this.headline,
                    html` <h2 class="text-[32px] lg:text-[42px] font-medium mb-0 text-center">${this.headline}</h2> `,
                )}
                ${when(
                    this.variant === 'slider',
                    html`
                        <mb-slider
                            swiper-options="${JSON.stringify({
                                spaceBetween: 16,
                                breakpoints: {
                                    640: {
                                        slidesPerView: 2,
                                        spaceBetween: 24,
                                    },
                                    768: {
                                        slidesPerView: 3,
                                        spaceBetween: 24,
                                    },
                                },
                            })}"
                        >
                            ${this.cards.map(
                                (card, index) => html`
                                    <div class="relative h-full" slot="slide-${index}">
                                        ${when(
                                            card.chipText,
                                            html`
                                                <mb-chip
                                                    variant="${card.chipVariant}"
                                                    text="${card.chipText}"
                                                    class="absolute right-24 top-16"
                                                ></mb-chip>
                                            `,
                                        )}
                                        <mb-content-card
                                            class="h-full"
                                            background-color="${card.backgroundColor ?? ''}"
                                            icon="${card.icon}"
                                            headline="${card.headline}"
                                            text="${card.text}"
                                            .link="${card.link}"
                                        ></mb-content-card>
                                    </div>
                                `,
                            )}
                        </mb-slider>
                    `,
                    html`
                        <div class="grid gap-fix-s md:gap-fix-xl ${classMap(gridClasses)}">
                            ${this.cards.map(
                                (card) => html`
                                    <mb-content-card
                                        background-color="${card.backgroundColor ?? ''}"
                                        icon="${card.icon}"
                                        headline="${card.headline}"
                                        text="${card.text}"
                                        .link="${card.link}"
                                    ></mb-content-card>
                                `,
                            )}
                        </div>
                    `,
                )}
                ${when(
                    this.link?.url && this.link?.text,
                    html` <a
                        href="${this.link?.url}"
                        class="Button btn btn-outline-primary sm:self-center"
                        element="content cards"
                    >
                        ${this.link?.text}
                    </a>`,
                )}
            </div>
        `;
    }
}

defineElement('mb-content-cards', ContentCards);
